package com.neurobs.ccabserver.transcriptreview.states

import com.neurobs.react.{BooleanAttribute, GenericState, GenericStateGenerator}
import org.scalajs.dom.console
import slinky.core.{FunctionalComponent, TagMod}
import slinky.core.annotations.react
import slinky.core.facade.Hooks.useState
import slinky.core.facade.ReactElement

case class VisibilityState
(
  spectrogram: BooleanAttribute,
  transcriptText: BooleanAttribute
) extends GenericState {

  def spectrogramIsVisible = spectrogram.value
  def toggleSpectrogramVisibility() = spectrogram.toggle()

  def transcriptTextIsVisible = transcriptText.value
  def toggleTranscriptTextVisibility() = transcriptText.toggle()
}

object VisibilityStateGenerator extends GenericStateGenerator[VisibilityState] {
  override def generateEmptyDefaultState(): VisibilityState = {
    VisibilityState(
      emptyBooleanState(),
      emptyBooleanState()
    )
  }
}

@react
object VisibilityStateProvider {
  case class Props(children: ReactElement*)

  val component = FunctionalComponent[Props] { props =>

    val spectrogramState = BooleanAttribute(useState(false))
    val transcriptTextState = BooleanAttribute(useState(true))

    val visibilityState = VisibilityState(
      spectrogramState,
      transcriptTextState
    )

    VisibilityStateGenerator.Provider(visibilityState)(
      props.children:_*
    )
  }
}

